import { SimpleProgressBar } from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';

import { ResolutionStage } from '../types';

function getProgressPercent(stage: ResolutionStage): number {
  switch (stage) {
    case 'initial':
      return 0;

    case 'prompt':
      return 25;

    case 'solution':
    case 'noSolution':
      return 50;

    case 'solutionArticleSelected':
    case 'noSolutionNoDraftArticle':
    case 'noSolutionDraftArticle':
      return 75;

    case 'solutionSubmitted':
    case 'noSolutionSubmitted':
    case 'noSolutionDraftArticleSubmitted':
      return 100;

    default:
      return 0;
  }
}

type ResolutionProgressBarProps = {
  stage: ResolutionStage;
};
export function ResolutionProgressBar({
  stage,
}: ResolutionProgressBarProps): JSX.Element | null {
  if (stage === 'cancelWarning') return null; // No progress bar shown when user tries to cancel the flow

  const progressPercent = getProgressPercent(stage);

  return (
    <SimpleProgressBar
      progress={progressPercent}
      base={100}
      progressColor={colors.green['500']}
      backgroundColor={colors.green['100']}
    />
  );
}
